'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Code = function Code(props) {
  return _react2.default.createElement(_Pane2.default, _extends({
    is: 'code'
  }, props, {
    textStyle: 'mono',
    border: true,
    tint: true,
    rounded: true,
    paddingX: '4px',
    paddingY: '2px'
  }));
};

Code.propTypes = _extends({}, _Pane2.default.propTypes);

exports.default = Code;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0NvZGUuanMiXSwibmFtZXMiOlsiQ29kZSIsInByb3BzIiwicHJvcFR5cGVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLE9BQU8sU0FBUEEsSUFBTyxDQUFDQyxLQUFEO0FBQUEsU0FDWDtBQUNFLFFBQUc7QUFETCxLQUVNQSxLQUZOO0FBR0UsZUFBVSxNQUhaO0FBSUUsZ0JBSkY7QUFLRSxjQUxGO0FBTUUsaUJBTkY7QUFPRSxjQUFTLEtBUFg7QUFRRSxjQUFTO0FBUlgsS0FEVztBQUFBLENBQWI7O0FBYUFELEtBQUtFLFNBQUwsZ0JBQ0ssZUFBS0EsU0FEVjs7a0JBSWVGLEkiLCJmaWxlIjoiQ29kZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBQYW5lIGZyb20gJy4vUGFuZSdcblxuY29uc3QgQ29kZSA9IChwcm9wcykgPT4gKFxuICA8UGFuZVxuICAgIGlzPSdjb2RlJ1xuICAgIHsuLi5wcm9wc31cbiAgICB0ZXh0U3R5bGU9J21vbm8nXG4gICAgYm9yZGVyXG4gICAgdGludFxuICAgIHJvdW5kZWRcbiAgICBwYWRkaW5nWD0nNHB4J1xuICAgIHBhZGRpbmdZPScycHgnXG4gIC8+XG4pXG5cbkNvZGUucHJvcFR5cGVzID0ge1xuICAuLi5QYW5lLnByb3BUeXBlc1xufVxuXG5leHBvcnQgZGVmYXVsdCBDb2RlXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Code.js
// module id = 1119
// module chunks = 0